module.exports = __webpack_public_path__ + "static/media/400036_02.185bec46.png";